module.exports = __webpack_public_path__ + "img/6001006000.61303d7.webp";